module.exports = __webpack_public_path__ + "img/FCB.7e0a3d2a.svg";